module.exports = __webpack_public_path__ + "static/media/05.37458819.png";